module.exports = __webpack_public_path__ + "img/VP-ECONew_Overview-Rear_1.5209257e.jpg";